'use client'
import { createContext, useContext } from 'react'

export type YouthSportsAnalyticsProps = {
  sport: string
  city: string
  pageType: string
  variant?: string
}

const YouthSportsAnalyticsContext = createContext<YouthSportsAnalyticsProps | null>(null)

export function YouthSportsAnalyticsProvider({
  children,
  sport,
  city,
  pageType,
  variant,
}: YouthSportsAnalyticsProps & { children: React.ReactNode }) {
  return (
    <YouthSportsAnalyticsContext.Provider value={{ sport, city, pageType, variant }}>
      {children}
    </YouthSportsAnalyticsContext.Provider>
  )
}

export function useYouthSportsAnalytics(): YouthSportsAnalyticsProps {
  const ctx = useContext(YouthSportsAnalyticsContext)
  if (!ctx) throw new Error('useYouthSportsAnalytics must be used inside YouthSportsAnalyticsProvider')
  return ctx
}
